import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginModel } from '../model/login.model';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ToolsService<T> {

  public logado: boolean = false;
  private usuario: LoginModel | undefined;
  private loginURL: string = 'api/PrecoCombustivel/consulta-preco-combustivel-json-async';
  constructor(private http: HttpClient) { }

  get(url: string): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      this.http.get<any>(url)
        .subscribe({
          complete: () => {
            //console.log('get complete');
          },
          error: (erro) => {
            reject(erro);
          },
          next: (data: T) => {
            //console.log('get next: ');
            resolve(data);
          }
        });
    })
  }

  post(url: string, dados: any): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      var h: HttpHeaders = new HttpHeaders();

      h.append("Accept", "application/json");
      h.append("Content-Type", "application/json");
      h.append("Accept-Language", "pt-BR,pt;q=0.9,en-US;q=0.8,en;q=0.7");

      const httpOptions = {
        headers: new HttpHeaders({
          "Accept": "application/json",
          'Content-Type': 'application/json',
          Authorization: 'my-auth-token'
        })
      };



      this.http.post<T>(url, JSON.stringify(dados), httpOptions)
        .subscribe({
          complete: () => {
            //console.log('post complete');
          },
          error: (erro) => {
            reject(erro);
          },
          next: (data: T) => {
            //console.log('post post: ');
            resolve(data);
          }
        });



    })
  }

  logarConsole(objeto: any) {
    if (!environment.production) {
      console.log(objeto);
    }
  }

  formatDecimal(
    value: any,
    replaceSign?: any,
    prefix?: any,
    suffix?: any,
    displayDecimalString?: boolean
  ) {
    if (value == undefined || value == null || String(value).length <= 0) {
      console.warn("formatDecimal", "value not defined");
      return;
    }

    if (displayDecimalString == undefined || displayDecimalString == null) {
      displayDecimalString = false;
    }

    if (prefix == undefined || prefix == null || !isNaN(prefix)) {
      prefix = "";
    }
    if (suffix == undefined || suffix == null || !isNaN(suffix)) {
      suffix = "";
    }

    try {
      var returnValue = null;

      var valueStr = String(value);

      if (valueStr.indexOf(",") == -1 && valueStr.indexOf(".") == -1) {
        valueStr = valueStr + ".00";
      }

      if (valueStr.indexOf(",") !== -1 && valueStr.indexOf(".") !== -1) {
        if (
          replaceSign != undefined &&
          replaceSign != null &&
          isNaN(replaceSign) &&
          (replaceSign == "," || replaceSign == ".")
        ) {
          if (replaceSign == ",") {
            valueStr = valueStr.replace(".", "");
          } else if (replaceSign == ".") {
            valueStr = valueStr.replace(",", "");
          }
        } else {
          valueStr = valueStr.replace(".", "");
        }
      }

      var floatRR = /[0-9]+(\,|\.)[0-9]{0,2}/;
      var strr = valueStr;
      var mm: any = floatRR.exec(strr);
      if (
        replaceSign != undefined &&
        replaceSign != null &&
        isNaN(replaceSign) &&
        (replaceSign == "," || replaceSign == ".")
      ) {
        //returnValue = prefix+mm[0].replace(".",replaceSign).replace(",",replaceSign)+suffix;
        returnValue = mm[0].replace(".", replaceSign).replace(",", replaceSign);
      } else {
        //returnValue = prefix+mm[0]+suffix;
        returnValue = mm[0];
      }

      //COLOCANDO OS PONTOS
      var valueSeparator = ".";
      var indexOf = returnValue.indexOf(",");
      if (indexOf == -1) {
        indexOf = returnValue.indexOf(".");
        valueSeparator = ",";
      }

      if (indexOf != -1) {
        var subLeft = returnValue.substring(0, indexOf);
        var subRight = returnValue.substring(indexOf);

        var newSubLeft = "";
        var countPt = 0;
        for (var j = subLeft.length - 1; j >= 0; j--) {
          countPt++;
          newSubLeft = subLeft[j] + newSubLeft;
          if (countPt == 3 && j - 1 >= 0) {
            countPt = 0;
            newSubLeft = valueSeparator + newSubLeft;
          } else if (countPt == 3) {
            countPt = 0;
          }
        }
        returnValue = newSubLeft + subRight;
      }
      //COLOCANDO OS PONTOS FIM

      //FIX DECIMAL VALUE
      if (displayDecimalString === true) {
        try {
          let subIndex = returnValue.indexOf(replaceSign);
          if (subIndex != -1 && returnValue.substring(subIndex).length <= 2) {
            returnValue += "0";
          }
        } catch (err) {
          console.warn(err);
        }
      }
      //FIX DECIMAL VALUE

      returnValue = prefix + returnValue + suffix;

      return returnValue;
    } catch (err) {
      console.warn(err);
    }

    return value;
  }

  formatDecimal2(
    value: any,
    replaceSign?: any,
    prefix?: any,
    suffix?: any,
    displayDecimalString?: boolean
  ) {
    if (value == undefined || value == null || String(value).length <= 0) {
      console.warn("formatDecimal", "value not defined");
      return;
    }

    if (displayDecimalString == undefined || displayDecimalString == null) {
      displayDecimalString = false;
    }

    if (prefix == undefined || prefix == null || !isNaN(prefix)) {
      prefix = "";
    }
    if (suffix == undefined || suffix == null || !isNaN(suffix)) {
      suffix = "";
    }

    try {
      var returnValue = null;

      var valueStr = String(value);

      if (valueStr.indexOf(",") == -1 && valueStr.indexOf(".") == -1) {
        valueStr = valueStr + ".000";
      }

      if (valueStr.indexOf(",") !== -1 && valueStr.indexOf(".") !== -1) {
        if (
          replaceSign != undefined &&
          replaceSign != null &&
          isNaN(replaceSign) &&
          (replaceSign == "," || replaceSign == ".")
        ) {
          if (replaceSign == ",") {
            valueStr = valueStr.replace(".", "");
          } else if (replaceSign == ".") {
            valueStr = valueStr.replace(",", "");
          }
        } else {
          valueStr = valueStr.replace(".", "");
        }
      }

      var floatRR = /[0-9]+(\,|\.)[0-9]{0,2}/;
      var strr = valueStr;
      var mm: any = floatRR.exec(strr);
      if (
        replaceSign != undefined &&
        replaceSign != null &&
        isNaN(replaceSign) &&
        (replaceSign == "," || replaceSign == ".")
      ) {
        //returnValue = prefix+mm[0].replace(".",replaceSign).replace(",",replaceSign)+suffix;
        returnValue = mm[0].replace(".", replaceSign).replace(",", replaceSign);
      } else {
        //returnValue = prefix+mm[0]+suffix;
        returnValue = mm[0];
      }

      //COLOCANDO OS PONTOS
      var valueSeparator = ".";
      var indexOf = returnValue.indexOf(",");
      if (indexOf == -1) {
        indexOf = returnValue.indexOf(".");
        valueSeparator = ",";
      }

      if (indexOf != -1) {
        var subLeft = returnValue.substring(0, indexOf);
        var subRight = returnValue.substring(indexOf);

        var newSubLeft = "";
        var countPt = 0;
        for (var j = subLeft.length - 1; j >= 0; j--) {
          countPt++;
          newSubLeft = subLeft[j] + newSubLeft;
          if (countPt == 3 && j - 1 >= 0) {
            countPt = 0;
            newSubLeft = valueSeparator + newSubLeft;
          } else if (countPt == 3) {
            countPt = 0;
          }
        }
        returnValue = newSubLeft + subRight;
      }
      //COLOCANDO OS PONTOS FIM

      //FIX DECIMAL VALUE
      if (displayDecimalString === true) {
        try {
          let subIndex = returnValue.indexOf(replaceSign);
          if (subIndex != -1 && returnValue.substring(subIndex).length <= 3) {
            returnValue += "0";
          }
        } catch (err) {
          console.warn(err);
        }
      }
      //FIX DECIMAL VALUE

      returnValue = prefix + returnValue + suffix;

      return returnValue;
    } catch (err) {
      console.warn(err);
    }

    return value;
  }


  /**
   * Converte um valor com vírgula para com ponto ( , -> .)
   * @param value
   * @param formatValue
   * @returns
   */
  convertToNumber(value: any, formatValue?: any) {
    try {
      if (formatValue == undefined || formatValue == null) {
        formatValue = false;
      }

      if (value != undefined && value != null) {
        if (isNaN(value) && value.indexOf(",") != -1) {
          while (value.indexOf(".") != -1) {
            value = value.replace(".", "");
          }
          while (value.indexOf(",") != -1) {
            value = value.replace(",", ".");
          }
        }

        if (formatValue === true) {
          return value;
        }

        return Number(value);
      }
    } catch (err) {
      console.warn(err);
    }

    return value;
  }

}
